import api from '../api'
const baseUrl = '/academy/api/AdminSetting'

const skillUpBannerProvider = {
  AddBanner(params) {
    return api.post(`${baseUrl}/GiftBanner`, params)
  },
  AddFirstSlider(params) {
    return api.post(`${baseUrl}/AddFirstSlider`, params)
  },
  changePartnerShip(params) {
    return api.post(`${baseUrl}/Partnership`, params)
  },
  changeOrganizationalService(params) {
    return api.post(`${baseUrl}/OrganizationalService`, params)
  },
  changeWhySkillUp(params) {
    return api.post(`${baseUrl}/WhySkillUp`, params)
  },
  updateBanner(params) {
    return api.put(`${baseUrl}/Banner`, params)
  },
  getBanner(id) {
    return api.get(`${baseUrl}/GetBanner/${id}`)
  },
  getPartnership() {
    return api.get(`${baseUrl}/GetPartnership`)
  },
  getBannerType(id) {
    return api.get(`${baseUrl}/GetBannerType/${id}`)
  },
  getOrganizationalService() {
    return api.get(`${baseUrl}/GetOrganizationalService`)
  },
  getWhySkillUp() {
    return api.get(`${baseUrl}/GetWhySkillUp`)
  },

  deleteBanner(id) {
    return api.delete(`${baseUrl}/DeleteBanner/${id}`)
  },
}

export default skillUpBannerProvider
